import PropTypes from 'prop-types';
import React from 'react';
import Subtitle from '../../components/Subtitle';
import { serviceShape, categoryShape, categoriesShape } from '../../shapes';
import NoServices from './NoServices';
import Categories from './Categories';
import Service from './Service';
import { nullFunc } from '../../utils/helpers';
import GiftCardService from './GiftCardService';

const Services = ({
  services,
  categories,
  generateUrlString,
  nested,
  onServiceClick,
  setCategory,
  resetCategory,
  selectedCategory,
}) => (
  <div>
    {!nested && <Subtitle>Choose a service</Subtitle>}
    <Categories
      categories={categories}
      setCategory={setCategory}
      resetCategory={resetCategory}
      selectedCategory={selectedCategory}
    />
    <div className="o-services-list-wrapper">
      <div className="layout">
        {!services.length && <NoServices />}
        {services.length > 0 && <GiftCardService /> }
        {services.length > 0 &&
          services.map(service => (
            <div className="layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up" key={service.id}>
              <Service service={service} generateUrlString={generateUrlString} onClick={onServiceClick(service.id)} />
            </div>
          ))}
      </div>
    </div>
  </div>
);
Services.propTypes = {
  services: PropTypes.arrayOf(serviceShape).isRequired,
  categories: categoriesShape,
  generateUrlString: PropTypes.func,
  nested: PropTypes.bool,
  onServiceClick: PropTypes.func,
  setCategory: PropTypes.func,
  resetCategory: PropTypes.func,
  selectedCategory: categoryShape,
};
Services.defaultProps = {
  categories: [],
  selectedCategory: undefined,
  generateUrlString: null,
  nested: false,
  onServiceClick: nullFunc,
  setCategory: nullFunc,
  resetCategory: nullFunc,
};

export default Services;



// WEBPACK FOOTER //
// ./src/app/services/components/Services.jsx